import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import { People } from "@material-ui/icons";
import Button from "./../components/CustomButtons/Button";
import CustomInput from "./../components/CustomInput/CustomInput";
import GridContainer from "./../components/Grid/GridContainer.js";
import GridItem from "./../components/Grid/GridItem.js";
import Card from "./../components/Card/Card.js";
import CardBody from "./../components/Card/CardBody.js";
import CardHeader from "./../components/Card/CardHeader.js";
import CardFooter from "./../components/Card/CardFooter.js";
import styles from "../assets/style/login";
import { authAPI } from "../services/AuthService";
import Swal from "sweetalert2";
import { checkEmail } from "../utils/config.js";

const useStyles = makeStyles(styles);

const ForgetPassword = (props) => {
  const [cardAnimaton, setCardAnimation] = useState("cardHidden");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  let history = useHistory();
  const EmailFunction = async (e) => {
    e.preventDefault();
    const { isConfirmed } = await Swal.fire({
      title: "คุณแน่ใจ ?",
      text: "ยืนยันการส่งข้อมูลไปยัง Email",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#56A834",
      cancelButtonColor: "#d33",
      confirmButtonText: "แน่ใจ",
      cancelButtonText: "ยังก่อน",
    });
    if (!isConfirmed) return;
    setLoading(true);
    authAPI
      .forgetPassword({ email })
      .then(async (res) => {
        if (res.status == 200) {
          await Swal.fire({
            icon: "success",
            confirmButtonColor: "#22c55e",
            html: `<span class="colorWhite">ส่งข้อมูลเปลี่ยนรหัสผ่านไปยัง Email ${email} ลิงค์หมดอายุภายใน 10 นาที</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            width: "28rem",
            timer: 3000,
          });
          history.push("/login");
        } else {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${res.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 3000,
          });
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          confirmButtonColor: "#f27474",
          html: `<span class="colorWhite">${error.message}</span>`,
          backdrop: "transparent",
          background: "rgba(0,0,0,.75)",
          customClass: {
            icon: "switch",
          },
          width: "28rem",
          timer: 3000,
        });
      });
  };

  useEffect(() => {
    document.title = "Com7 Merchandise - Forget Password";
    let mytimeout = setTimeout(() => {
      setCardAnimation("");
    }, 700);
    return () => {
      clearTimeout(mytimeout);
    };
  }, []);

  const classes = useStyles();

  return (
    <div onSubmit={EmailFunction}>
      <div
        className={classes.pageHeader}
        style={{
          backgroundSize: "cover",
          backgroundPosition: "top center",
        }}
      >
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={4}>
              <Card
                className={classes[cardAnimaton]}
                style={{ borderRadius: "10px" }}
              >
                <form className={classes.form}>
                  <CardHeader color="primary" className={classes.cardHeader}>
                    <h3>Merchandise Messenger</h3>
                  </CardHeader>
                  <p className={classes.divider}>
                    โปรดป้อนอีเมลของคุณเพื่อส่งลิงค์เปลี่ยนรหัสผ่าน
                  </p>
                  <CardBody>
                    <CustomInput
                      values={email}
                      setValues={setEmail}
                      labelText="Email..."
                      id="email"
                      type="email"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "email",
                        endAdornment: (
                          <InputAdornment position="end">
                            <People className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </CardBody>
                  <CardFooter
                    className={classes.cardFooter}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "2px",
                    }}
                  >
                    <Button
                      className={classes.cardButton}
                      simple
                      type="submit"
                      color={`${!checkEmail(email) ? "danger" : "primary"}`}
                      style={{
                        borderRadius: "15px",
                        boxShadow: `0 5px 5px -50px ${
                          !checkEmail(email) ? "lightgray" : "#6ab23a"
                        }, 0 2px 15px -5px ${
                          !checkEmail(email) ? "lightgray" : "#6ab23a"
                        },0 12px 20px -10px ${
                          !checkEmail(email) ? "lightgray" : "#6ab23a"
                        }`,
                      }}
                      size="lg"
                      disabled={!checkEmail(email) || loading}
                      onClick={EmailFunction}
                    >
                      ยืนยัน
                    </Button>
                    <Button
                      className={classes.cardButton}
                      simple
                      type="button"
                      color={"primary"}
                      size="lg"
                      disabled={loading}
                      onClick={() => history.push("/login")}
                    >
                      กลับ
                    </Button>
                  </CardFooter>
                </form>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    </div>
  );
};
export default ForgetPassword;
